export default {
	action: "Transfer ownership",
	confirmTitle: "Transfer ownership",
	confirmMessage:
		"{name} will get a request to become the Owner; if they accept, you become an Administrator.",
	confirm: "Send request",
	requested: "Request sent; waiting for {name} to answer.",
	pendingSent: "Transfer to {name} awaiting an answer until {date}.",
	cancel: "Cancel request",
	canceled: "Request canceled.",
	pageTitle: "Ownership transfer",
	pendingReceived: "{name} wants to transfer the ownership of {temple} to you.",
	explanation: "If you accept, you become the Owner, and {name} stays as an Administrator.",
	expiresAt: "The request is valid until {date}.",
	accept: "Accept",
	decline: "Decline",
	acceptedRelogin: "Transfer completed: log out and back in to use your Owner access.",
	accepted: "You are now the Owner of the temple.",
	declined: "Request declined.",
	none: "No pending ownership transfer.",
	banner: "You received a request to take over the ownership of the temple.",
	viewRequest: "View request",
	error: "Could not complete; please try again.",
};
